import React, { Component } from 'react';

const SocialTooltips = ({ title }) => {
  return <div className="socialTooltip">{title}</div>;
};

export default SocialTooltips;
